import {Command} from "commander";
import migration from './makers/migration'
import model_migration from './makers/model_migration'
import model from './makers/model'
import {camelCase} from "lodash/string";
// import { Generator } from '@paljs/generator';
import getDataSchema from "../../utils/getDataSchema";
import path from "path";
import fs from "fs";
import {getDMMF} from "@prisma/sdk";
import { sdlInputs } from '@paljs/plugins';
import {print} from "graphql";
import Generator from "../../utils/Generator";

module.exports = function (program: Command) {
    program
        .command('make:migration [name]')
        .option('-u, --update <bool>', 'Update table instead of create', false)
        .option('-t, --table <string>', 'Target table name')
        .description('Create migration')
        .action((name, {table, update}) => {
            if (!table && !name) {
                throw new Error('Either name the migration, or provide table name');
            }
            migration(table, name, update)
        });

    program
        .command('make:model-migration [name]')
        .description('Create migration from existing model')
        .action(async (name) => {
            await model_migration(name)
        });

    program
        .command('make:model <name>')
        .option('-m, --migration', 'Add corresponding migration')
        // TODO
        // .option('-f, --field <value>', 'Fields in name:type format', (v, p) => p.concat([v]), [])
        // .option('-i, --interactive', 'Interactive mode')
        .description('Create a GraphQL base model')
        .action((name, {migration, field, interactive}) => {
            model(name, field);
            if (migration) {
                migration(null, name.charAt(0).toUpperCase() + camelCase(name).slice(1))
            }
        });

    program
        .command('make:crud')
        .description('Create base crud from datamodel')
        .action(async () => {
            // https://paljs.com/generator
            await require('mkdirp')(path.join(process.cwd(), '.easy-gql'));
            const schemaPath = path.join(process.cwd(), '.easy-gql', 'dataschema.prisma');
            const datamodelPath = path.join(process.cwd(), '.easy-gql', 'datamodel.json');
            const output = path.join(process.cwd(), 'api', 'src', 'crud');
            console.log(`Generating CRUD to ${output} directory`)
            const schema = await getDataSchema();
            const dmmf = await getDMMF({datamodel: schema});
            await fs.promises.writeFile(schemaPath, schema)
            await fs.promises.writeFile(datamodelPath, JSON.stringify(dmmf))
            await new Generator({ name: 'openCRUD', schemaPath }, {output}).run();
            await fs.promises.writeFile(path.join(output, 'inputs.ts'), `import gql from 'graphql-tag'

export default gql\`
${print(sdlInputs({dmmf, doNotUseFieldUpdateOperationsInput: true}))
            .replace(/^/gm, '  ')}\``);
            await fs.promises.writeFile(
                path.join(output, 'typedefs.ts'),
                (await fs.promises.readFile(path.join(output, 'typedefs.ts'), 'utf-8'))
                    .replace("import { sdlInputs } from '@paljs/plugins'", "import inputs from './inputs'")
                    .replace("sdlInputs()", "inputs")
            )
            await fs.promises.writeFile(path.join(output, 'index.ts'), await fs.promises.readFile(path.join(__dirname, 'templates', 'crud.ts.stub'), 'utf-8'));
            // nasty, but there is no proper program api for this
            require('child_process').execSync('npx prisma generate --schema=.easy-gql/dataschema.prisma');
            console.log('CRUD generated')
        });
}
